import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScriptLoaderService {
    private loadedScripts: Set<string> = new Set();

    /**
     * Charge dynamiquement un script externe.
     * @param id identifiant unique du script (ex: "google", "apple", "facebook")
     * @param src URL du script
     */
    loadScript(id: string, src: string): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this.loadedScripts.has(id) || document.getElementById(id)) {
                resolve();
                return;
            }

            const script = document.createElement('script');
            script.id = id;
            script.src = src;
            script.async = true;
            script.defer = true;
            script.onload = () => {
                this.loadedScripts.add(id);
                resolve();
            };
            script.onerror = () => reject(`Script load failed: ${src}`);
            document.body.appendChild(script);
        });
    }

    /** Google */
    loadGoogleScript(): Promise<void> {
        return this.loadScript('google-client-script', 'https://accounts.google.com/gsi/client');
    }

    /** Apple */
    loadAppleScript(): Promise<void> {
        return this.loadScript(
            'apple-client-script',
            'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
        );
    }

    /** Facebook */
    loadFacebookScript(): Promise<void> {
        return this.loadScript(
            'facebook-client-script',
            'https://connect.facebook.net/en_US/sdk.js'
        );
    }
}
